import { GetProps, Space, SpaceProps } from 'antd';

type SpaceCompactProps = GetProps<typeof Space.Compact>;

const BCSpace = (props: SpaceProps) => <Space {...props} />;

const BCSpaceCompact = (props: SpaceCompactProps) => <Space.Compact {...props} />;

export { BCSpace, BCSpaceCompact };
